import { useState } from 'react';
import { C, t } from '../../Dashboard/components/dashboardConstants';

const COLORS = ['#E94934', '#FFD92B', '#FFA40D', '#007AD2'];
const ICONS = ['📺', '🎬', '🎭', '🌟'];

const COLOR_TO_BG = {
  '#E94934': '#FDECEA',
  '#FFD92B': '#FFF8D5',
  '#FFA40D': '#FFF3E0',
  '#007AD2': '#EBF3FF',
};

export default function NewBoardModal({ onClose, onCreate, initialData = null }) {
  const isEdit = !!initialData;
  const [name, setName] = useState(initialData?.name || '');
  const [desc, setDesc] = useState(initialData?.desc || '');
  const [color, setColor] = useState(initialData?.color || COLORS[0]);
  const [icon, setIcon] = useState(initialData?.emoji || ICONS[0]);

  const handleSubmit = () => {
    if (!name.trim()) return;
    const bg = COLOR_TO_BG[color] || '#FFF8D5';
    onCreate({ name: name.trim(), desc, emoji: icon, bg, color });
  };

  return (
    <div style={{
      position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.55)',
      display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000,
    }} onClick={onClose}>
      <div style={{
        background: C.white, borderRadius: '20px',
        padding: '60px 50px', width: '780px', boxSizing: 'border-box',
        display: 'flex', flexDirection: 'column', gap: '30px', position: 'relative',
      }} onClick={e => e.stopPropagation()}>

        {/* 헤더 */}
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', paddingBottom: '30px'}}>
          <h2 style={{ ...t('36px', 600, C.bk), margin: 0 }}>{isEdit ? '보드 수정하기' : '새 보드 만들기'}</h2>
          <button onClick={onClose} style={{ background: 'none', border: 'none', cursor: 'pointer', padding: 0 }}>
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
              <path d="M18 6L6 18M6 6l12 12" stroke={C.g400} strokeWidth="2" strokeLinecap="round"/>
            </svg>
          </button>
        </div>

        {/* 보드 이름 */}
        <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
            <span style={t('20px', 500, C.bk)}>보드 이름</span>
            <span style={{ color: C.orange, fontSize: '20px', fontWeight: 600 }}>*</span>
          </div>
          <input
            value={name}
            onChange={e => setName(e.target.value)}
            placeholder="예 : 관심 공고, 지원 예정"
            style={{
              width: '100%', height: '60px', padding: '0 18px', boxSizing: 'border-box',
              background: C.bg, border: `1px solid ${C.g200}`, borderRadius: '10px',
              ...t('18px', 400, C.g400), outline: 'none',
            }}
          />
        </div>

        {/* 설명 */}
        <div style={{ display: 'flex', flexDirection: 'column', gap: '18px' }}>
          <span style={t('20px', 600, C.bk)}>설명</span>
          <textarea
            value={desc}
            onChange={e => setDesc(e.target.value)}
            placeholder="이 보드에 대한 간단한 설명을 입력하세요."
            style={{
              width: '100%', height: '180px', padding: '18px', boxSizing: 'border-box',
              background: C.bg, border: `1px solid ${C.g200}`, borderRadius: '10px',
              ...t('18px', 400, C.g400), outline: 'none', resize: 'none',
            }}
          />
        </div>

        {/* 색상 */}
        <div style={{ display: 'flex', flexDirection: 'column', gap: '18px' }}>
          <span style={t('20px', 600, C.bk)}>색상</span>
          <div style={{ display: 'flex', gap: '10px' }}>
            {COLORS.map(c => (
              <button key={c} onClick={() => setColor(c)} style={{
                width: '40px', height: '40px', borderRadius: '10px',
                background: c, cursor: 'pointer', border: 'none', flexShrink: 0,
                outline: c === color ? `2px solid ${C.bk}` : 'none', outlineOffset: '2px',
                display: 'flex', alignItems: 'center', justifyContent: 'center',
              }}>
                {c === color && (
                  <svg width="16" height="12" viewBox="0 0 16 12" fill="none">
                    <path d="M1 6l4.5 4.5L15 1" stroke={C.white} strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                )}
              </button>
            ))}
          </div>
        </div>

        {/* 아이콘 */}
        <div style={{ display: 'flex', flexDirection: 'column', gap: '18px' }}>
          <span style={t('20px', 600, C.bk)}>아이콘</span>
          <div style={{ display: 'flex', gap: '10px' }}>
            {ICONS.map(ic => (
              <button key={ic} onClick={() => setIcon(ic)} style={{
                width: '40px', height: '40px', borderRadius: '10px', fontSize: '20px',
                background: C.white, cursor: 'pointer',
                border: `1px solid ${ic === icon ? C.bk : C.g200}`,
                boxShadow: ic === icon ? C.shadow : 'none',
              }}>
                {ic}
              </button>
            ))}
          </div>
        </div>

        {/* 버튼 */}
        <div style={{ display: 'flex', justifyContent: 'center', gap: '15px' }}>
          <button onClick={onClose} style={{
            width: '90px', height: '50px', background: C.g200, border: 'none',
            borderRadius: '10px', cursor: 'pointer', ...t('18px', 600, C.sub),
          }}>
            취소
          </button>
          <button onClick={handleSubmit} style={{
            width: '120px', height: '50px', background: C.bk, border: 'none',
            borderRadius: '10px', cursor: 'pointer', ...t('18px', 600, C.white),
          }}>
            {isEdit ? '수정하기' : '보드 만들기'}
          </button>
        </div>
      </div>
    </div>
  );
}
